import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Form from '../../../../../components/Form'

import { selectedPartnershipRightsHolderIdSelector } from '../../../../../modules/selectors/partnerships'
import {
  createAdServerErrorSelector,
  createAdServerIsLoadingSelector,
  createAdServerWasCreatedSelector
} from '../../../../../modules/selectors/adServer'
import { clearCreateAdServer, createAdServer } from '../../../../../modules/actions/adServer'

import { AD_SERVER_ACCESS_CREATE } from '../../../../../constants/forms'
import { AD_SERVER_TYPE, API_KEY, validationSchema } from '../reusableFields'
import { initialValues } from './fields'

import AdServerFormFields from '../AdServerFormFields'

function AdServerAccessCreateForm() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const adServerWasCreated = useSelector(createAdServerWasCreatedSelector)

  const selectedPartnershipRightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)

  const onSubmit = useCallback(
    values => {
      dispatch(
        createAdServer({
          [API_KEY]: values[API_KEY],
          [AD_SERVER_TYPE]: values[AD_SERVER_TYPE],
          account: selectedPartnershipRightsHolderId
        })
      )
    },
    [dispatch, selectedPartnershipRightsHolderId]
  )

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })

  useEffect(() => {
    if (adServerWasCreated) {
      // reset redux state after successful adServer creation
      dispatch(clearCreateAdServer())
    }
  }, [dispatch, adServerWasCreated])

  return (
    <Form
      formik={formik}
      method="post"
      formName={AD_SERVER_ACCESS_CREATE}
      successSubmit={adServerWasCreated}
      errorSelector={createAdServerErrorSelector}
      isLoadingSelector={createAdServerIsLoadingSelector}
      submitText={t('Save')}
    >
      <AdServerFormFields formik={formik} />
    </Form>
  )
}

export default AdServerAccessCreateForm
